<template>
  <div id="message">
    <div class="message-title">通知</div>
    <div class="message-banner">
      <div @click="switchReadList" class="message-banner-item" v-bind:class="{ 'message-banner-item-active' : !unreadStatus, 'message-banner-item-no-active' : unreadStatus }">全部</div>
      <div @click="switchReadList" class="message-banner-item" v-bind:class="{ 'message-banner-item-active' : unreadStatus, 'message-banner-item-no-active' : !unreadStatus }">未读</div>
    </div>
    <div class="message-list">
      <div v-if="list && list.length > 0">
        <div v-for="(item, index) in list" class="message-item" :key="index" @click="readMsg(item, index)">
          <div class="message-avatar">
            <div class="message-avatar-pic">
              <van-icon name="chat-o" />
              <div v-if="item.unread === 'unread'" class="message-avatar-no-read"></div>
            </div>
          </div>
          <div class="message-content">
            <div class="message-content-title">{{ item.title }}</div>
            <div class="message-content-content">{{ item.content && item.content.msg }}</div>
          </div>
          <div class="message-time">{{ item.datetime }}</div>
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无消息" />
      </div>
    </div>
  </div>
</template>

<script>
import {getMessageList, markMessage} from '../api/message'
import {Toast} from 'vant'

export default {
  name: 'message',
  data () {
    return {
      image: 'https://img01.yzcdn.cn/vant/cat.jpeg',
      isWeixin: false,
      queryForm: {
        read_status: '',
        page: 1,
        page_size: 20
      },
      unreadStatus: false,
      list: [{
        avatar: '',
        title: '普通消息',
        type: 1,
        id: 1,
        date: '',
        desc: '欢迎登陆',
        url: '',
        is_read: 1
      }]
    }
  },
  created () {
    this.getInfo()
    this.initList()
    if (this.isWechat()) {
      this.isWeixin = true
    }
  },
  methods: {
    getInfo () {
    },
    switchReadList () {
      this.unreadStatus = !this.unreadStatus
      this.queryForm.read_status = this.unreadStatus ? 'unread' : ''
      this.queryForm.page = 1
      this.initList()
    },
    initList () {
      getMessageList(this.queryForm).then((res) => {
        if (res.data.data.list) {
          this.list = res.data.data.list
        }
      })
    },
    isWechat () {
      let ua = window.navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    readMsg (data, index) {
      console.log('data......', data)
      let that = this
      if (data.unread && data.unread === 'unread') {
        markMessage({message_id: data.message_id}).then((res) => {
          if (res.data.code > 0) {
            Toast(res.data.msg)
          } else {
            that.$store.dispatch('notice/setMessageCnt')
            that.initList()
          }
        })
      }
      if (data.url) {
        this.$router.push(data.url)
      }
      if (data.message_type === 'supplierApproveCoReport') {
        this.$router.push({path: '/warranty_list'})
      }
      if (data.message_type === 'worker_appoint_order') {
        this.$router.push({path: '/warranty_list'})
      }
      if (data.message_type === 'workerTip_push_day') {
        this.$router.push({path: '/order_calendar'})
      }

      if (data.message_type === 'approve_reim') {
        this.$router.push({path: '/order_reimbursement', query: {reim_id: data.content && data.content.reim_id } })
      }
    }
  }
}
</script>

<style scoped>
.message-title {
  font-size: 24px;
  text-align: left;
  font-weight: bold;
  width: 90%;
  margin: 10px auto;
}
.message-list {
  margin-top: 4px;
}
.message-banner-item {
  float: left;
  border-radius: 14px;
  font-size: 14px;
  width: 50px;
  height: 24px;
  margin-right: 10px;
  line-height: 26px;
  margin-left: 10px;
  text-align: center;
}
.message-banner-item-active {
  color: #FFFFFF;
  background: #F5978B;
}
.message-banner-item-no-active {
  color: #6e7a8a;
  background: #F2F3F5;
}
.message-banner {
  overflow: hidden;
  border-bottom: solid 1px #FFFF;
}
.message-item {
  width: 100%;
  border-bottom: solid 1px #F1F1F1;
  overflow: hidden;
  background-color: #FFFFFF;
}
.message-avatar {
  padding-top: 10px;
  float: left;
  overflow: hidden;
  width: 20%;
}
.message-avatar-pic {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  padding-bottom: 8px;
  position: relative;
}
.message-avatar-no-read {
  position: absolute;
  left: 30px;
  top: 0px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: red;
}
.message-content {
  float: left;
  padding: 10px 0;
  width: 60%;
  overflow: hidden;
}
.message-content-title {
  font-size: 14px;
  font-weight: bold;
  height: 20px;
  line-height: 20px;
  color: #303030;
  text-align: left;
}
.message-content-content {
  font-size: 12px;
  height: 12px;
  line-height: 28px;
  margin-bottom: 10px;
  text-overflow: clip ellipsis;
  color: #989898;
  text-align: left;
}
.message-time {
  float: right;
  width: 18%;
  margin-top: 10px;
  margin-right: 2%;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/message.vue